<template>
    <slot name="input" :value="activeValue" />
    <div ref="root" class="relative mb-2 border-b border-black">
        <div
            class="mt-4 flex cursor-pointer items-center justify-between py-1"
            @click="visible = !visible">
            <span
                class="-mt-1 origin-left transition-transform"
                :class="!!activeValue ? 'mt-0 -translate-y-full scale-75 pb-0' : 'pb-1'">
                {{ title }}<span v-if="required" class="pl-1 text-sm">*</span>
            </span>
            <span class="absolute w-full pr-4 line-clamp-1" :class="activeTitleClasses">
                {{ activeTitle || ' ' }}
            </span>
            <lz-icon
                name="chevron"
                class="h-3 w-3 stroke-current transition-transform duration-300"
                :class="visible ? '-rotate-90' : 'rotate-90'" />
        </div>
    </div>
    <collapse-transition v-show="visible">
        <div
            class="dropdown-scrollbar absolute left-0 z-30 max-h-36 w-full overflow-y-auto overflow-x-hidden bg-white shadow-lg lg:max-h-44">
            <slot :select="select" />
        </div>
    </collapse-transition>
</template>

<script lang="ts" setup>
import { defineEmits, defineProps, onBeforeUnmount, onMounted, ref, withDefaults } from 'vue';
import LzIcon from './LzIcon.vue';
import { DropdownItem } from '@/types';

const emit = defineEmits(['change']);
const props = withDefaults(
    defineProps<{
        title?: string;
        required?: boolean;
        activeTitleClasses?: string;
    }>(),
    {
        title: '',
        required: false,
        activeTitleClasses: ''
    }
);

const visible = ref(false);
const root = ref<HTMLElement | null>(null);
const activeTitle = ref('');
const activeValue = ref('');

onMounted(() => {
    document.addEventListener('click', onOutsideClicked);
});

onBeforeUnmount(() => {
    document.removeEventListener('click', onOutsideClicked);
});

function select(item: DropdownItem) {
    if (item.value === activeValue.value) {
        activeValue.value = '';
        activeTitle.value = '';
        emit('change', '');
        return;
    }
    activeTitle.value = item.label;
    activeValue.value = item.value;
    visible.value = false;
    emit('change', activeValue.value);
}

function onOutsideClicked(event: MouseEvent) {
    let target = event.target as Node;
    do {
        if (target === root.value) {
            return;
        }
        target = target.parentNode as Node;
    } while (target);
    visible.value = false;
}
</script>
